export default "__VITE_ASSET__e6456d46__"